import { Icon, Typography } from '@repo/ui';
import {
  ButtonColors,
  ButtonVariants,
  Card,
  DesignButton,
} from 'components';

import styles from './ActionsReminderCard.module.css';

// Mobile-only reminder above the Related Actions card. Scrolls to the
// provided ref (typically the Action Items section) when tapped.
// Hidden on desktop via CSS (≥ 992px).
type Props = {
  relatedActionsQty: number;
  scrollTargetRef: React.RefObject<HTMLElement>;
};

export default function ActionsReminderCard({
  relatedActionsQty,
  scrollTargetRef,
}: Props) {
  if (!relatedActionsQty) return null;

  const handleScroll = () => {
    if (!scrollTargetRef.current) return;
    const scrollContainer = document.querySelector('#appWrapper');
    scrollContainer?.scrollTo({
      top: scrollTargetRef.current.offsetTop - 10,
      behavior: 'smooth',
    });
  };

  return (
    <Card className={styles.actionsReminder}>
      <div className='flex gap-2'>
        <div className={styles.iconWrapper}>
          <Icon name='flashFilled' size='m' />
        </div>
        <div className='flex flex-column gap-1'>
          <Typography variant='heading-s'>
            {`${relatedActionsQty} actions related to this metric`}
          </Typography>
          <DesignButton
            label='See actions'
            iconNameRight='chevronForward'
            color={ButtonColors.WHITE}
            variant={ButtonVariants.TEXT}
            onClick={handleScroll}
          />
        </div>
      </div>
    </Card>
  );
}
